import type { ReactNode } from 'react';

/**
 * Standard error banner used above or inside run-detail cards.
 *
 * `title` is rendered as bold lead-in (default 'Error:'); callers that want a
 * different framing (e.g. 'Analysis failed.') pass it in. Body comes from
 * children.
 *
 * See docs/FeatureDesigns/operation-detail-unified-layout.md.
 */
export function ErrorBanner({ title = 'Error:', children }: { title?: string; children: ReactNode }) {
    return (
        <div className="error-banner" role="alert">
            <strong>{title}</strong> {children}
        </div>
    );
}

/**
 * Full-width error card used as the last section of a detail page when the
 * operation itself failed.
 */
export function ErrorCard({ title = 'Error', children }: { title?: string; children: ReactNode }) {
    return (
        <div className="card error-card">
            <h3>{title}</h3>
            <div className="error-message">{children}</div>
        </div>
    );
}
